import React from 'react';
import AuthExperience from './AuthExperience';

const Login = () => <AuthExperience defaultTab="login" />;

export default Login;